<template>
  <v-row>
    <v-row>
      <v-col class="align-left">
        <ExpandCollapseToggle
          id="signsPanelToggle"
          @toggleAllPanels="toggleAllPanels"
          styleClass="mt-3"
          :panel="panel"
        />
      </v-col>
      <v-col class="align-right mt-2">
        <ValidationCountsHeader v-if="moduleType == MODULE_TYPES.MANAGEMENT" />
      </v-col>
    </v-row>
    <v-expansion-panels v-model="panel" multiple color="#fff">
      <v-expansion-panel class="mt-5">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="!panel.includes(0)" icon="fa-solid fa-plus" />
          <v-icon v-if="panel.includes(0)" icon="fa-solid fa-minus" />
          <h3>Sign & Light Conditions</h3>
        </v-expansion-panel-title>

        <v-expansion-panel-text eager>
          <v-form v-model="valid" ref="modifySignsLightsForm">
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="6">
                <LabelSelect
                  labelXl="5"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  id="sel_Overall_Condition_Rating"
                  label="SL.20 Overall Condition Rating"
                  :refTable="REFERENCE_TABLE.SIGN_LIGHT_CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="signsLightsValue.STRRATING"
                  isRequired
                ></LabelSelect>
              </v-col>
            </v-row>

            <CommentTypeTextField
              v-if="moduleType == MODULE_TYPES.INSPECTION"
              label="Overall Sign & Light Notes"
              id="field_Overall Sign & Light Notes"
              :inspectionCommentType="INSPECTION_COMMENTS.OVERALL"
              :readonly="!isEditable"
              :counter="inspCommentMaxLength"
              :maxlength="inspCommentMaxLength"
              @changesDetected="inspectionStore.setDirtyFlag(true)"
            />
            <ManagementCommentTypeTextField
              v-else
              label="Overall Sign & Light Notes"
              id="field_Overall Sign & Light Notes"
              :inspectionCommentType="INSPECTION_COMMENTS.OVERALL"
              :readonly="!isEditable"
              :counter="inspCommentMaxLength"
              :maxlength="inspCommentMaxLength"
              :comments="signsLightsValue.inspectionComments"
              :brkey="signsLightsValue.BRKEY"
              :inspectionId="signsLightsValue.INSPECTIONID"
              @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.OVERALL)"
            />

            <v-row>
              <v-col cols="12" sm="12" md="12" lg="6" class="pr-lg-3">
                <LabelSelect
                  labelXl="5"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  id="sel_Foundation"
                  label="SL.21 Foundation"
                  :refTable="REFERENCE_TABLE.SIGN_LIGHT_CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="signsLightsValue.BASE_COND_RATE"
                  isRequired
                ></LabelSelect>

                <LabelSelect
                  labelXl="5"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  id="sel_Guide_Rail"
                  label="SL.22 Guide Rail"
                  :refTable="REFERENCE_TABLE.SIGN_LIGHT_CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="signsLightsValue.GRAIL_COND_RATE"
                  isRequired
                ></LabelSelect>

                <LabelSelect
                  labelXl="5"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  id="sel_Column"
                  label="SL.23 Column"
                  :refTable="REFERENCE_TABLE.SIGN_LIGHT_CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="signsLightsValue.COLUMN_COND_RATE"
                  isRequired
                ></LabelSelect>

                <LabelSelect
                  labelXl="5"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  id="sel_Method_of_Access"
                  label="SL.24 Method of Access"
                  :refTable="REFERENCE_TABLE.SIGN_LIGHT_CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="signsLightsValue.ACCESS_COND_RATE"
                  isRequired
                ></LabelSelect>

                <LabelSelect
                  labelXl="5"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  id="sel_Sign"
                  label="SL.25 Sign"
                  :refTable="REFERENCE_TABLE.SIGN_LIGHT_CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="signsLightsValue.SIGN_COND_RATE"
                  isRequired
                ></LabelSelect>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="6" class="pl-lg-3">
                <LabelSelect
                  labelXl="5"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  id="sel_Lights"
                  label="SL.26 Lights"
                  :refTable="REFERENCE_TABLE.SIGN_LIGHT_CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="signsLightsValue.LIGHT_COND_RATE"
                  isRequired
                ></LabelSelect>

                <LabelSelect
                  labelXl="5"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  id="sel_Surface_Paint"
                  label="SL.27 Surface/Paint"
                  :refTable="REFERENCE_TABLE.SIGN_LIGHT_CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="signsLightsValue.SURFACE_COND_RATE"
                  isRequired
                ></LabelSelect>

                <LabelSelect
                  labelXl="5"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  id="sel_Horizontal_Member_Frame"
                  label="SL.28 Horizontal Member/Frame"
                  :refTable="REFERENCE_TABLE.SIGN_LIGHT_CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="signsLightsValue.HOR_COND_RATE"
                  isRequired
                ></LabelSelect>

                <LabelSelect
                  labelXl="5"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  id="sel_Sign_Asset_Tag_Condition"
                  label="SL.29 Sign Asset Tag Condition"
                  :refTable="REFERENCE_TABLE.SIGN_ASSET_TAG"
                  :isEditable="isEditable"
                  v-model="signsLightsValue.SIGN_ASSET_TAG"
                  isRequired
                ></LabelSelect>
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="!panel.includes(1)" icon="fa-solid fa-plus" />
          <v-icon v-if="panel.includes(1)" icon="fa-solid fa-minus" />
          <h3>Sign & Light Inspection Notes</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <CommentTypeTextField
            v-if="moduleType == MODULE_TYPES.INSPECTION"
            label="Foundation"
            id="field_Foundation"
            :inspectionCommentType="INSPECTION_COMMENTS.SIGN_COLUMN_BASE"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            @changesDetected="inspectionStore.setDirtyFlag(true)"
          />
          <ManagementCommentTypeTextField
            v-else
            label="Foundation"
            id="field_Foundation"
            :inspectionCommentType="INSPECTION_COMMENTS.SIGN_COLUMN_BASE"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            :comments="signsLightsValue.inspectionComments"
            :brkey="signsLightsValue.BRKEY"
            :inspectionId="signsLightsValue.INSPECTIONID"
            @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.SIGN_COLUMN_BASE)"
          />
          <CommentTypeTextField
            v-if="moduleType == MODULE_TYPES.INSPECTION"
            label="Guide Rail"
            id="field_Guide_Rail"
            :inspectionCommentType="INSPECTION_COMMENTS.SIGN_GUIDE_RAIL"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            @changesDetected="inspectionStore.setDirtyFlag(true)"
          />
          <ManagementCommentTypeTextField
            v-else
            label="Guide Rail"
            id="field_Guide_Rail"
            :inspectionCommentType="INSPECTION_COMMENTS.SIGN_GUIDE_RAIL"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            :comments="signsLightsValue.inspectionComments"
            :brkey="signsLightsValue.BRKEY"
            :inspectionId="signsLightsValue.INSPECTIONID"
            @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.SIGN_GUIDE_RAIL)"
          />
          <CommentTypeTextField
            v-if="moduleType == MODULE_TYPES.INSPECTION"
            label="Column"
            id="field_Column"
            :inspectionCommentType="INSPECTION_COMMENTS.SIGN_COLUMN"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            @changesDetected="inspectionStore.setDirtyFlag(true)"
          />
          <ManagementCommentTypeTextField
            v-else
            label="Column"
            id="field_Column"
            :inspectionCommentType="INSPECTION_COMMENTS.SIGN_COLUMN"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            :comments="signsLightsValue.inspectionComments"
            :brkey="signsLightsValue.BRKEY"
            :inspectionId="signsLightsValue.INSPECTIONID"
            @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.SIGN_COLUMN)"
          />
          <CommentTypeTextField
            v-if="moduleType == MODULE_TYPES.INSPECTION"
            label="Method of Access"
            id="field_Method of Access"
            :inspectionCommentType="INSPECTION_COMMENTS.SIGN_ACCESS_METH"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            @changesDetected="inspectionStore.setDirtyFlag(true)"
          />
          <ManagementCommentTypeTextField
            v-else
            label="Method of Access"
            id="field_Method of Access"
            :inspectionCommentType="INSPECTION_COMMENTS.SIGN_ACCESS_METH"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            :comments="signsLightsValue.inspectionComments"
            :brkey="signsLightsValue.BRKEY"
            :inspectionId="signsLightsValue.INSPECTIONID"
            @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.SIGN_ACCESS_METH)"
          />
          <CommentTypeTextField
            v-if="moduleType == MODULE_TYPES.INSPECTION"
            label="Sign"
            id="field_Sign"
            :inspectionCommentType="INSPECTION_COMMENTS.SIGN_SIGN"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            @changesDetected="inspectionStore.setDirtyFlag(true)"
          />
          <ManagementCommentTypeTextField
            v-else
            label="Sign"
            id="field_Sign"
            :inspectionCommentType="INSPECTION_COMMENTS.SIGN_SIGN"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            :comments="signsLightsValue.inspectionComments"
            :brkey="signsLightsValue.BRKEY"
            :inspectionId="signsLightsValue.INSPECTIONID"
            @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.SIGN_SIGN)"
          />
          <CommentTypeTextField
            v-if="moduleType == MODULE_TYPES.INSPECTION"
            label="Lights"
            id="field_Lights"
            :inspectionCommentType="INSPECTION_COMMENTS.SIGN_LIGHTS"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            @changesDetected="inspectionStore.setDirtyFlag(true)"
          />
          <ManagementCommentTypeTextField
            v-else
            label="Lights"
            id="field_Lights"
            :inspectionCommentType="INSPECTION_COMMENTS.SIGN_LIGHTS"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            :comments="signsLightsValue.inspectionComments"
            :brkey="signsLightsValue.BRKEY"
            :inspectionId="signsLightsValue.INSPECTIONID"
            @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.SIGN_LIGHTS)"
          />
          <CommentTypeTextField
            v-if="moduleType == MODULE_TYPES.INSPECTION"
            label="Surface/Paint"
            id="field_Surface_Paint"
            :inspectionCommentType="INSPECTION_COMMENTS.SIGN_SURFACE_PAINT"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            @changesDetected="inspectionStore.setDirtyFlag(true)"
          />
          <ManagementCommentTypeTextField
            v-else
            label="Surface/Paint"
            id="field_Surface_Paint"
            :inspectionCommentType="INSPECTION_COMMENTS.SIGN_SURFACE_PAINT"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            :comments="signsLightsValue.inspectionComments"
            :brkey="signsLightsValue.BRKEY"
            :inspectionId="signsLightsValue.INSPECTIONID"
            @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.SIGN_SURFACE_PAINT)"
          />
          <CommentTypeTextField
            v-if="moduleType == MODULE_TYPES.INSPECTION"
            label="Horizontal Member/Frame"
            id="field_Horizontal_Member_Frame"
            :inspectionCommentType="INSPECTION_COMMENTS.SIGN_FRAMEWORK"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            @changesDetected="inspectionStore.setDirtyFlag(true)"
          />
          <ManagementCommentTypeTextField
            v-else
            label="Horizontal Member/Frame"
            id="field_Horizontal_Member_Frame"
            :inspectionCommentType="INSPECTION_COMMENTS.SIGN_FRAMEWORK"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            :comments="signsLightsValue.inspectionComments"
            :brkey="signsLightsValue.BRKEY"
            :inspectionId="signsLightsValue.INSPECTIONID"
            @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.SIGN_FRAMEWORK)"
          />
          <CommentTypeTextField
            v-if="moduleType == MODULE_TYPES.INSPECTION"
            label="Sign Asset Tag Condition"
            id="field_Sign_Asset_Tag_Condition"
            :inspectionCommentType="INSPECTION_COMMENTS.SIGN_ASSET_TAGS"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            @changesDetected="inspectionStore.setDirtyFlag(true)"
          />
          <ManagementCommentTypeTextField
            v-else
            label="Sign Asset Tag Condition"
            id="field_Sign_Asset_Tag_Condition"
            :inspectionCommentType="INSPECTION_COMMENTS.SIGN_ASSET_TAGS"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            :comments="signsLightsValue.inspectionComments"
            :brkey="signsLightsValue.BRKEY"
            :inspectionId="signsLightsValue.INSPECTIONID"
            @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.SIGN_ASSET_TAGS)"
          />
        </v-expansion-panel-text>
      </v-expansion-panel> </v-expansion-panels
  ></v-row>
</template>

<script>
import { ref, computed, watch, onMounted } from "vue";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { useInspectionStore } from "@/stores/inspection";
import LabelSelect from "@/components/common/LabelSelect.vue";
import CommentTypeTextField from "@/components/common/CommentTypeTextField.vue";
import { INSPECTION_COMMENTS } from "@/constants/Inspections";
import { useConfigStore } from "@/stores/config";
import { ENV_CONFIG_PROPERTY } from "@/constants/EnvConfigProperties";
import { clone } from "@/util/clone";
import objSignLightInsp from "@/data/signsLights";
import ExpandCollapseToggle from "@/components/shared/ExpandCollapseToggle.vue";
import { useSignAndLightsStore } from "@/components/inspection/store/signsLights";
import { useQuickSearchStore } from "@/stores/quickSearch";
import { useInspectionLinksStore } from "@/stores/inspectionLinks";
import { storeToRefs } from "pinia";
import { MODULE_TYPES } from "@/constants/InspectionConstants";
import ManagementCommentTypeTextField from "@/components/common/ManagementCommentTypeTextField.vue";
import { useUserPermissionStore } from "@/stores/userPermission";
import { SIGNS_AND_LIGHTS_PERMISSIONS } from "@/rbac";
import { ACCESS_LEVELS } from "@/rbac/accessLevels.js";
import { INSPECTION_STATUSES } from "@/constants/InspectionStatuses";
import { SNACKBAR_MARKER, SNACKBAR_MESSAGE_TYPES } from "@/constants/GlobalSnackbar";
import { useSnackbarStore } from "@/stores/snackbar";
import { STRUCTURE_SEARCH_MESSAGES } from "@/constants/StructureSearches";
import ValidationCountsHeader from "@/components/shared/ValidationCountsHeader.vue";

export default {
  name: "InspectionSignsLights",
  props: {
    moduleType: { default: MODULE_TYPES.INSPECTION },
  },
  setup(props) {
    const allPanels = [0, 1, 2, 3];
    const panel = ref(allPanels);
    const inspectionStore = useInspectionStore();
    const signandLightStore = useSignAndLightsStore();
    const quickSearchStore = useQuickSearchStore();
    const structureHeader = computed(() => quickSearchStore.getStructure());
    const { hasQuickSearchSucceeded } = storeToRefs(quickSearchStore);
    const inspectionLinksStore = useInspectionLinksStore();
    const userPermissionStore = useUserPermissionStore();
    const structure = computed(() => inspectionStore.selectedInspection);
    const snackbarStore = useSnackbarStore();
    const configStore = useConfigStore();
    let signsLightsValue = ref({});
    let valid = ref(true);
    let modifySignsLightsForm = ref(null);
    let resetDirty = ref(false);
    let snackBarId = ref(null);
    onMounted(async () => {
      await readData();
    });
    const isEditable = computed(() => {
      if (props.moduleType == MODULE_TYPES.MANAGEMENT) {
        return hasQuickSearchSucceeded.value && signsLightsValue?.value?.BRKEY && hasAccessToEdit.value;
      } else {
        return inspectionStore.isEditable;
      }
    });
    if (!isEditable.value) {
      panel.value = allPanels;
    }
    const inspCommentMaxLength = computed(() => {
      return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.INSPECTION_COMMENT_MAX_LENGTH);
    });

    async function validate() {
      await modifySignsLightsForm.value.validate();
    }

    function defaultSignLightInsp() {
      if (!structure.value?.signLightInspection) {
        objSignLightInsp.brkey = structure.value.structureBridge.brkey;
        objSignLightInsp.inspectionId = structure.value.inspection.inspectionId;
        objSignLightInsp.createdDateTime = new Date().toISOString();
        objSignLightInsp.createdUserId = structure.value.inspection.updateUserId;
        structure.value.signLightInspection = clone(objSignLightInsp);
      }
    }

    const readData = async () => {
      let isSuccess = false;
      signsLightsValue.value = {};
      resetDirty.value = true;
      if (
        props.moduleType == MODULE_TYPES.MANAGEMENT &&
        structureHeader.value?.BRKEY &&
        structureHeader.value.INSPECTIONID
      ) {
        if (!hasQuickSearchSucceeded.value) {
          resetDirty.value = true;
          return;
        }
        isSuccess = await signandLightStore.loadDataObject(
          props.moduleType,
          structureHeader.value.BRKEY,
          structureHeader.value.INSPECTIONID,
        );
        if (isSuccess) {
          signsLightsValue.value = signandLightStore.getSignAndLights();
        } else {
          showErrorMessage();
        }
      } else if (props.moduleType == MODULE_TYPES.INSPECTION) {
        defaultSignLightInsp();
        await signandLightStore.loadDataObject(props.moduleType, null, null, structure.value);
        signsLightsValue.value = signandLightStore.getSignAndLights();
      }
      resetDirty.value = true;
      await validate();
    };

    const saveChanges = async () => {
      const isSuccess = await signandLightStore.saveData(props.moduleType, signsLightsValue.value, structure.value);
      if (isSuccess) {
        await readData();
        inspectionLinksStore.isDirty = false;
      }
      return isSuccess;
    };

    const cancelChanges = async () => {
      await readData();
      inspectionLinksStore.isDirty = false;
    };

    const setUpdatedComment = (comment, commentType) => {
      const foundComment = signsLightsValue.value.inspectionComments.find((c) => {
        return c.commentType === commentType;
      });
      if (foundComment) {
        foundComment.notes = comment.notes;
        foundComment.updateUserId = comment.updateUserId;
        foundComment.updateDateTime = comment.updateDateTime;
      } else {
        signsLightsValue.value.inspectionComments.push(comment);
      }
    };

    const hasAccessToEdit = computed({
      get() {
        if (structureHeader.value?.INSPECTIONSTATUS === INSPECTION_STATUSES.ACCEPTED) {
          return userPermissionStore.checkUserPermission(
            SIGNS_AND_LIGHTS_PERMISSIONS[ACCESS_LEVELS.CUSTOM.EDIT_APPROVED_INSPECTION],
            userPermissionStore.getUserPermissionByBrkeyFromCache(signsLightsValue.value.BRKEY),
          );
        } else {
          return userPermissionStore.checkUserPermission(
            SIGNS_AND_LIGHTS_PERMISSIONS[ACCESS_LEVELS.EDIT],
            userPermissionStore.getUserPermissionByBrkeyFromCache(signsLightsValue.value.BRKEY),
          );
        }
      },
    });

    const strrating = computed({
      get: () => structure.value?.signLightInspection?.strRating,
      set: (value) => {
        structure.value.signLightInspection.strRating = value;
      },
    });

    const baseCondRate = computed({
      get: () => structure.value?.signLightInspection?.baseCondRate,
      set: (value) => {
        structure.value.signLightInspection.baseCondRate = value;
      },
    });

    const grailCondRate = computed({
      get: () => structure.value?.signLightInspection?.grailCondRate,
      set: (value) => {
        structure.value.signLightInspection.grailCondRate = value;
      },
    });
    const columnCondRate = computed({
      get: () => structure.value?.signLightInspection?.columnCondRate,
      set: (value) => {
        structure.value.signLightInspection.columnCondRate = value;
      },
    });
    const accessCondRate = computed({
      get: () => structure.value?.signLightInspection?.accessCondRate,
      set: (value) => {
        structure.value.signLightInspection.accessCondRate = value;
      },
    });
    const signCondRate = computed({
      get: () => structure.value?.signLightInspection?.signCondRate,
      set: (value) => {
        structure.value.signLightInspection.signCondRate = value;
      },
    });
    const lightCondRate = computed({
      get: () => structure.value?.signLightInspection?.lightCondRate,
      set: (value) => {
        structure.value.signLightInspection.lightCondRate = value;
      },
    });
    const surfaceCondRate = computed({
      get: () => structure.value?.signLightInspection?.surfaceCondRate,
      set: (value) => {
        structure.value.signLightInspection.surfaceCondRate = value;
      },
    });
    const horCondRate = computed({
      get: () => structure.value?.signLightInspection?.horCondRate,
      set: (value) => {
        structure.value.signLightInspection.horCondRate = value;
      },
    });
    const signAssetTag = computed({
      get: () => structure.value?.signLightInspection?.signAssetTag,
      set: (value) => {
        structure.value.signLightInspection.signAssetTag = value;
      },
    });

    const showErrorMessage = () => {
      if ((snackBarId.value === null || snackBarId.value === "") && !quickSearchStore.getErrorMessage()) {
        snackBarId.value = snackbarStore.showMessage({
          displayText: STRUCTURE_SEARCH_MESSAGES.SEARCH_NO_RESULTS,
          messageType: SNACKBAR_MESSAGE_TYPES.ERROR_CUSTOM,
          timeout: 10000,
          callback: () => {
            snackBarId.value = null;
          },
        });
      }
    };

    const toggleAllPanels = (expandAll) => {
      if (expandAll) {
        panel.value = allPanels;
      } else {
        panel.value = [];
      }
    };

    const printD491 = () => {
      return { reportPage: "D491-Insp-SignsLights-Screen", marker: SNACKBAR_MARKER.SIGN_AND_LIGHTS };
    };

    // watch those objects used in component from structure to warn about unsaved changes
    watch(
      signsLightsValue,
      () => {
        // This watch will NOT be triggered during initial onMounted()
        if (props.moduleType === MODULE_TYPES.MANAGEMENT) {
          // for management module
          if (resetDirty.value) {
            inspectionLinksStore.isDirty = false;
            resetDirty.value = false;
          } else {
            inspectionLinksStore.isDirty = true;
          }
        } else if (props.moduleType === MODULE_TYPES.INSPECTION) {
          // for inspection  module
          if (resetDirty.value) {
            inspectionStore.setDirtyFlag(false);
            resetDirty.value = false;
          } else {
            inspectionStore.setDirtyFlag(true);
          }
        }
      },
      { deep: true },
    );

    watch(
      () => [props],
      () => {
        readData();
      },
      { deep: true },
    );

    return {
      panel,
      REFERENCE_TABLE,
      isEditable,
      structure,
      INSPECTION_COMMENTS,
      configStore,
      inspCommentMaxLength,
      valid,
      modifySignsLightsForm,
      validate,
      strrating,
      baseCondRate,
      grailCondRate,
      columnCondRate,
      accessCondRate,
      signCondRate,
      lightCondRate,
      surfaceCondRate,
      horCondRate,
      signAssetTag,
      toggleAllPanels,
      saveChanges,
      readData,
      cancelChanges,
      signsLightsValue,
      MODULE_TYPES,
      setUpdatedComment,
      printD491,
      inspectionStore,
    };
  },
  components: {
    LabelSelect,
    CommentTypeTextField,
    ExpandCollapseToggle,
    ManagementCommentTypeTextField,
    ValidationCountsHeader,
  },
};
</script>
